import * as React from 'react';
import { useContext } from 'react';
import { Button } from '../../../../../../shared/ui/button';
import { Flex } from '../../../../../components/common/flex';
import { UserContext } from '../../../../../components/contexts/user_context';

interface IBookCanceledProps {
  bookId: number;
}

export const BookCanceled: React.FC<IBookCanceledProps> = ({ bookId }) => {
  const userContext = useContext(UserContext);

  const handleGoToBookings = (event: React.MouseEvent) => {
    if (userContext.sign_in_url) {
      event.preventDefault();
      window.location.href = userContext.sign_in_url;
    }
  };

  return (
    <Flex vertical gap={27} className={'approve-book-section'}>
      <Flex vertical gap={20}>
        <h2 className={'approve-book-section__title typography-h2'}>К сожалению, заявка {bookId} была отменена</h2>
        <div className={'approve-book-section__container'}>
          <span>Для просмотра всех заявок и бронирований перейдите в Экстранет.</span>
        </div>
      </Flex>
      <Flex className={'approve-book-section__container'}>
        <Button href={'/bookings'} onClick={handleGoToBookings} variant={'outline'} size={'large'}>
          Перейти к бронированиям
        </Button>
      </Flex>
    </Flex>
  );
};
